import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { posts } from '../data/posts';
import SEO from '../components/common/SEO';

const BlogIndex = () => {
  const latestPost = posts[0];
  const olderPosts = posts.slice(1);

  return (
    <div className="pt-32 pb-24 px-4 sm:px-6 lg:px-8 bg-white">
      <SEO 
        title="Journal" 
        description="Systems, psychology, and frameworks for ADHD creators. High-contrast insights for high-velocity production." 
        canonical="/blog" 
      />
      
      <div className="max-w-7xl mx-auto">
        <header className="mb-20">
          <h1 className="text-6xl sm:text-7xl lg:text-8xl font-black uppercase tracking-tighter text-zinc-950 leading-[0.85]">
            The <br />
            <span className="text-zinc-300">Journal.</span>
          </h1>
        </header>

        {/* Hero Post */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-32 border-b border-zinc-100 pb-20"
        >
          <Link to={`/blog/${latestPost.slug}`} className="group block">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400 mb-4 block">Latest Entry — {latestPost.date}</span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-zinc-950 leading-tight mb-6 group-hover:text-zinc-700 transition-colors">
              {latestPost.title}
            </h2>
            <p className="text-xl text-zinc-500 max-w-3xl leading-relaxed mb-8">
              {latestPost.excerpt}
            </p>
            <span className="inline-flex items-center text-sm font-black uppercase tracking-widest text-zinc-950 group-hover:translate-x-2 transition-transform">
              Read Entry &rarr;
            </span>
          </Link>
        </motion.div>

        {/* Older Posts Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-24">
          {olderPosts.map((post, index) => (
            <motion.article 
              key={post.slug}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <Link to={`/blog/${post.slug}`} className="group block">
                <span className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-400 mb-4 block">{post.date}</span>
                <h3 className="text-2xl font-bold text-zinc-950 mb-4 group-hover:text-zinc-600 transition-colors">
                  {post.title}
                </h3>
                <p className="text-zinc-500 leading-relaxed mb-6 line-clamp-3">
                  {post.excerpt}
                </p>
                <span className="text-xs font-black uppercase tracking-widest text-zinc-950">
                  Read &rarr;
                </span>
              </Link>
            </motion.article>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlogIndex;